
export const getVideoId = (url: string, platform: string): string | null => {
  if (platform === 'youtube') {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  } else if (platform === 'vimeo') {
    const regExp = /vimeo\.com\/([0-9]+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  }
  return null;
};

export const createEmbedHtml = (videoId: string, platform: 'youtube' | 'vimeo', caption?: string): string => {
  let embedHtml = '';
  
  if (platform === 'youtube') {
    embedHtml = `<div class="video-embed youtube-embed">
      <iframe 
        width="560" 
        height="315" 
        src="https://www.youtube.com/embed/${videoId}" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
      ></iframe>
      ${caption ? `<p class="video-caption">${caption}</p>` : ''}
    </div>`;
  } else if (platform === 'vimeo') {
    embedHtml = `<div class="video-embed vimeo-embed">
      <iframe 
        src="https://player.vimeo.com/video/${videoId}" 
        width="560" 
        height="315" 
        frameborder="0" 
        allow="autoplay; fullscreen; picture-in-picture" 
        allowfullscreen
      ></iframe>
      ${caption ? `<p class="video-caption">${caption}</p>` : ''}
    </div>`;
  }
  
  return embedHtml;
};
